// extracted by mini-css-extract-plugin
export default {"cusCard":"AIReportList_cusCard__Gfj5k","content":"AIReportList_content__q8BO2"};